import React from "react";
import { Field } from "formik";
import { TextField } from "@material-ui/core";

const PromptField = ({ touched, errors, label }) => (
  <Field
    as={TextField}
    label={label}
    name="prompt"
    multiline
    rows={6}
    fullWidth
    margin="dense"
    error={touched.prompt && Boolean(errors.prompt)}
    helperText={touched.prompt && errors.prompt}
  />
);

export default PromptField;
